import React from 'react'
import styled from 'styled-components';
import notfound from "../../assets/images/notfound.svg"

const Div = styled.div`
    width : 100%;
    height: 400px;
    position : relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`
const Img = styled.img`
    width: 300px;
    height: 300px;
    @media(max-width:800px){
        width: 200px;
        height: 200px;
    }
`
function ImageError(){
    return(
        <Div>
            <Img src={notfound} />
            <p>Mohon maaf server sedang error.</p>
        </Div>
    )
}
export default ImageError;